const axios = require("axios");

axios.default.defaults.xsrfCookieName = "CSRF-TOKEN"
axios.default.defaults.xsrfHeaderName = "X-CSRF-Token"
axios.default.defaults.withCredentials = true

const axiosService = axios.create({
  headers: { 'Content-Type': 'application/json' },
})

let redirectingToLogin = false

axiosService.interceptors.response.use(
  ({ data }) => data,
  ({ response }) => {

    const isPmSessionExpired = response?.status === 401
      && response.config?.url?.startsWith('/api/project_manager/')
      && window.location.pathname.startsWith('/project_manager')

    if (isPmSessionExpired && !window.location.pathname.startsWith('/project_manager/login')) {
      if (!redirectingToLogin) {
        redirectingToLogin = true
        window.location.href = '/project_manager/login'
      }
      return new Promise(() => {})
    }

    return Promise.reject(response)
  }
)

export default axiosService
